<template>
  <div class="choose-wallet-container">
    <div class="choose-wallet">
      <div class="title">Choose wallet</div>
      <div class="content">
        <div
          v-for="(connector, index) in connectors"
          :key="index"
          class="wallet-item"
          @click="handleLogin(connector.id)"
        >
          <img :src="`/images/${connector.id}.png`" class="logo" />
          <div class="name">{{ connector.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  data() {
    return {
      isShowChooseWallet: false
    };
  },
  computed: {
    connectors() {
      return [
        ...Object.keys(config.configWallet.connectors).map(
          key => config.configWallet.connectors[key]
        )
      ].filter(connector => !(window.isMobile && connector === 'bsc'));
    }
  },
  methods: {
    async handleLogin(connectorId) {
      this.$emit('close-choose-wallet-modal');
      if (
        connectorId === 'metamask' &&
        (!window.ethereum || !window.ethereum.isMetaMask)
      ) {
        const link = document.createElement('a');
        link.href = config.metamaskDeeplink;
        document.body.appendChild(link);
        link.click();
        return;
      }
      await this.$store.dispatch('auth/connect', connectorId);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.choose-wallet-container {
  height: fit-content;
  padding: 10px 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  width: 500px;
  .add-wallet {
    padding: 50px 0;
    img {
      margin: auto;
      width: 50px;
    }
    p {
      font-weight: 600;
      font-size: 26px;
      line-height: 32px;
      color: #203a54;
      margin: 20px 0 30px 0;
      font-family: Inter-Medium;
    }
    button {
      background: #5b6ef5;
      border-radius: 6px;
      padding: 12px 20px;
      color: #ffffff;
      font-size: 14px;
      width: 200px;
      font-family: Inter-Medium;
    }
  }

  .choose-wallet {
    .title {
      font-size: 20px;
      font-family: Inter-Bold;
      color: #10172a;
      text-align: center;
    }
    .content {
      display: flex;
      justify-content: space-evenly;
      flex-wrap: wrap;
      padding: 0px 30px;
      width: 100%;
      .wallet-item {
        cursor: pointer;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0px;
        width: 120px;
        img {
          width: 35px;
        }
        .name {
          margin-top: 5px;
          white-space: nowrap;
        }
        &:hover {
          color: #6b8cf9;
        }
      }
    }
  }
}

@media (max-width: $breakpoint-mobile) {
  .choose-wallet-container {
    width: 400px;
  }
}
@media (max-width: $breakpoint-m-mobile) {
  .choose-wallet-container {
    width: 360px;
  }
}
</style>
